'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("checkEcheanceService", function ($modal, $http, $dialogBox, $q) {
  var createPopinOptions = {
    controller: "CheckEcheanceEditionController",
    template: require("./checkEcheanceEdition.html")
  };
  return {
    openPopin: function openPopin(produitId, echeance) {
      return $modal.open(_.extend(createPopinOptions, {
        vars: {
          produitId: produitId,
          echeance: echeance
        },
        options: {
          width: 600
        }
      }));
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/checkEcheance/checkEcheanceService.js
// module id = 2687
// module chunks = 13